import WebHttpClient from '~src/httpClient/WebHttpClient';

import { IGetSiteEncryptionDataKeyResult } from '../models/CredentialEncryptionModels';
import { DeactivateSiteEncryptionDataKeyRequest, DeactivateSiteEncryptionDataKeyResult } from '../serverApi/requests/DeactivateSiteEncryptionDataKeyRequest';
import { GetSiteEncryptionDataKeyRequest } from '../serverApi/requests/GetSiteEncryptionDataKeysRequest';
import { RestoreSiteEncryptionDataKeyRequest, RestoreSiteEncryptionDataKeyResult } from '../serverApi/requests/RestoreSiteEncryptionDataKeyRequest';
import { RotateSiteEncryptionDataKeyRequest, RotateSiteEncryptionDataKeyResult } from '../serverApi/requests/RotateSiteEncryptionDataKeyRequest';

export function retrieveSiteEncryptionKey(): Promise<IGetSiteEncryptionDataKeyResult>  {
  const isComplete = (result: IGetSiteEncryptionDataKeyResult): boolean => {
    return result != null;
  };

  return WebHttpClient.sendRequest(new GetSiteEncryptionDataKeyRequest({}));
}

export function activateSiteEncryptionKey(request: RestoreSiteEncryptionDataKeyRequest): Promise<RestoreSiteEncryptionDataKeyResult>  {
  const isComplete = (result: RestoreSiteEncryptionDataKeyResult): boolean => {
    return result != null;
  };

  return WebHttpClient.sendRequest(request);
}

export function deactivateSiteEncryptionKey(request: DeactivateSiteEncryptionDataKeyRequest): Promise<DeactivateSiteEncryptionDataKeyResult>  {
  const isComplete = (result: DeactivateSiteEncryptionDataKeyResult): boolean => {
    return result != null;
  };

  return WebHttpClient.sendRequest(request);
}

export function rotateSiteEncryptionKey(request: RotateSiteEncryptionDataKeyRequest): Promise<RotateSiteEncryptionDataKeyResult>  {
  const isComplete = (result: RotateSiteEncryptionDataKeyResult): boolean => {
    return result != null;
  };

  return WebHttpClient.sendRequest(request);
}

export const ExtractEncryptionKeyService = {
  retrieveSiteEncryptionKey: retrieveSiteEncryptionKey,
  activateSiteEncryptionKey: activateSiteEncryptionKey,
  deactivateSiteEncryptionKey: deactivateSiteEncryptionKey,
  rotateSiteEncryptionKey: rotateSiteEncryptionKey
};